const offers = {
  err_ats_offer_already_created: {
    message: 'Offer has already been created.',
  },
  err_ats_offer_not_found: {
    message: 'Offer not found.',
  },
  err_unsupported_attachment_type: {
    message:
      "This file type can't be sent for signing. Use PDF, DOC, DOCX, JPG, or PNG.",
  },
  err_invalid_event: {
    message:
      'Unable to send the offer for approval. Refresh the page and try again.',
  },
  err_requisition_not_found: {
    message:
      "Requisition doesn't exist or user doesn't have permission to view.",
  },
  err_requisition_already_closed: {
    message: 'Requisition is already closed.',
  },
  err_requisition_already_archived: {
    message: 'Requisition is already archived.',
  },
  err_permission_denied: {
    message: 'You do not have permission to perform this action.',
  },
  err_requisition_already_associated: {
    message: 'Req is already in use. Try again with a different one.',
  },
  err_requisition_code_required: {
    message: 'Offer creation failed. Requisition code is required.',
  },
  err_approval_reviewers_empty: {
    message:
      'This offer requires approval from a hiring manager. Please add one to the job in the Hiring Team tab.',
  },
  // Fired when the offer's rel_user ("Users") field an approval step reads its
  // reviewers from has no one selected.
  err_approval_reviewer_field_empty: {
    message:
      'A reviewer field required by the approval template is empty. Please select at least one user for it before sending for approval.',
  },
  err_approval_reviewer_inactive: {
    message:
      'A reviewer required by the approval template is deactivated or deleted. Please update the reviewer field and try again.',
  },
  // Removing a "Users" field that an approval step reads its reviewers from is
  // rejected by the BE until the field is detached from those approval flows.
  err_field_used_in_approval: {
    message:
      'This field is used as a reviewer in one or more approval steps and cannot be deleted. Remove it from those approval flows first.',
  },
};
export default offers;
